import { createSystem, defaultConfig, defineConfig, defineTokens } from '@chakra-ui/react';

import { globalNocowanieStyles } from './misc/global-nocowanie.styles';
import { keyframes } from './misc/keyframes';
import { textStyles } from './misc/text-styles';
import { accommodationTileSlotRecipe } from './recipes/accommodation-tile';
import { averageRatingSlotRecipe } from './recipes/average-rating';
import { badgeRecipe } from './recipes/badge';
import { buttonRecipe } from './recipes/button';
import { cssTooltipSlotRecipe } from './recipes/css-tooltip';
import { headingRecipe } from './recipes/heading';
import { iconSlotRecipe } from './recipes/icon';
import { linkRecipe } from './recipes/link';
import { listSlotRecipe } from './recipes/list';
import { priceSlotRecipe } from './recipes/price';
import { ratingSlotRecipe } from './recipes/rating';
import { colors as semanticColors } from './semantic-tokens/colors';
import { shadows } from './semantic-tokens/shadows';
import { animations } from './tokens/animations';
import { colors } from './tokens/colors';
import { fontSizes } from './tokens/font-sizes';
import { fonts } from './tokens/fonts';
import { radii } from './tokens/radii';
import { sizes } from './tokens/sizes';
import { spacing } from './tokens/spacing';
import { zIndex } from './tokens/z-index';

export const raspberryEsiRootClass = 'nocowanie-root';
const cssScope = `:where(.${raspberryEsiRootClass}, [data-part="positioner"])`;

export const raspberryEsiBaseTheme = defineConfig({
    preflight: {
        scope: cssScope,
    },
    disableLayers: true, // Disbale layer styles so they are not overriden by legacy styles
    globalCss: {
        [cssScope]: {
            fontFamily: 'inherit',
        },
        ...globalNocowanieStyles,
    },

    theme: {
        breakpoints: {
            // for some reason `base` breakpoint is not defined by default, which causes issues with breakpoint-based hooks,
            // we need to add it manually
            base: '0rem', // 0px
            ...defaultConfig?.theme?.breakpoints,
        },
        tokens: defineTokens({
            animations,
            colors,
            spacing,
            radii,
            sizes,
            fonts,
            fontSizes,
            zIndex,
        }),

        semanticTokens: {
            colors: semanticColors,
            shadows,
        },

        keyframes,

        textStyles,

        // for defining component recipes
        recipes: {
            badge: badgeRecipe,
            button: buttonRecipe,
            heading: headingRecipe,
            link: linkRecipe,
        },

        // for defining component slot recipes
        slotRecipes: {
            accommodationTile: accommodationTileSlotRecipe,
            averageRating: averageRatingSlotRecipe,
            icon: iconSlotRecipe,
            list: listSlotRecipe,
            price: priceSlotRecipe,
            rating: ratingSlotRecipe,
            cssTooltip: cssTooltipSlotRecipe,
        },
    },
});

export const raspberryEsiTheme = createSystem(defaultConfig, raspberryEsiBaseTheme);
